import React, {useState} from "react"
import {Button, Dropdown, DropdownButton, FormControl, InputGroup, Modal} from "react-bootstrap"
import {postInviteOrg, postInviteTeam} from "../../lib/api";
import * as EmailValidator from 'email-validator';
import DropdownScope from "./DropdownScope";

function MemberSelector(props: { org: any, team: any, emails: string, addUser: any, instructions1: string, instructions2: string }) {
  const {org, team, emails, addUser, instructions1, instructions2} = props;
  // @ts-ignore
  const users = [];
  org.users.forEach((user: any) => {
    if (team && !team.users.find((teamUser: any) => teamUser.id === user.id)
      && emails.indexOf(user.email) === -1) {
      users.push(user);
    }
  })

  if (users.length === 0) {
    return (
      <div className="row pb-3">
        <div className="col">
          {instructions1}
        </div>
      </div>
    );
  }

  // @ts-ignore
  const items = users.map((user: any) => {
      const givenName = user.givenName || '';
      const familyName = user.familyName || '';
      const displayName = `${givenName === user.email ? '' : givenName} ${familyName || ''} ${user.email}`;

      return (
        <Dropdown.Item key={`dropdown-scope-${user.id}`} onClick={() => addUser(user)}>
          {displayName}
        </Dropdown.Item>
      );
    }
  );

  return (
    <>
      <div className="row pb-3">
        <div className="col">
          {instructions2}
        </div>
      </div>
      <div className="row pb-3">
        <div className="col">
          <Dropdown onClick={(e: any)=> e.stopPropagation()}>
          <DropdownButton key="dropdown-button" variant="secondary" menuAlign="left" title="Choose existing members">
              {items}
            </DropdownButton>
          </Dropdown>
        </div>
      </div>
    </>
  );
}

function InvitePeople(props: {
  org: any,
  team?: any,
  permissionAdmin: boolean,
  loadData: any,
  show: boolean;
  onHide: () => void;
}) {
  const {org, team, permissionAdmin, loadData, show, onHide} = props;
  const [emails, setEmails] = useState('');
  const [error, setError] = useState(null);
  const [scope, setScope] = useState('Member');
  const [enabled, setEnabled] = useState(true);
  const MAX_EMAILS = 10; // need an async backend to handle more in case of cognito timeouts

  function showModal() {
    setEnabled(true);
    setError(null);
    setEmails('');
  }

  function inviteUsers() {
    setError(null);
    setEnabled(false);
    if (!validateEmails()) {
      return
    }

    if (team) {
      postInviteTeam(emails, scope, org.id, team!.id)
        .then(postResponseHandler);
    } else {
      postInviteOrg(emails, scope, org.id)
        .then(postResponseHandler);
    }
  }

  function postResponseHandler(response: any) {
    setEnabled(true);
    if (response.ok) {
      onHide()
      loadData()
    } else {
      // @ts-ignore
      response.json().then(json => {
        setError(json?.error);
      });
    }
  }

  function validateEmails() {
    const emailList = emails
      .replace(/[\r\n\t]/g, "")
      .split(',')
      .map((email: string) => email.trim())
      .filter((email) => email.length > 0);

    const badEmails = emailList.filter((email: string) => !EmailValidator.validate(email));

    const errors = [];

    if (badEmails.length === 1) {
      errors.push(`${badEmails[0]} does not look like a valid email`);
    }
    if (badEmails.length > 1) {
      errors.push(`These do not look like valid emails: ${badEmails.join(', ')}`);
    }
    if (emailList.length === 0) {
      errors.push("Please enter at least 1 email");
    }
    if (emailList.length > MAX_EMAILS) {
      errors.push(`Please enter ${MAX_EMAILS} emails at a time`);
    }

    if (errors.length > 0) {
      // @ts-ignore
      setError({message: errors.join(', ')});
    }

    setEmails(emailList.join(', '));

    return errors.length === 0;
  }

  const addUser = function (user: any) {
    if (emails.trim().length > 0) {
      setEmails(`${emails}, ${user.email}`);
    } else {
      setEmails(user.email);
    }
  }

  let title: string;
  const instructions1 = `Enter comma separated emails up to ${MAX_EMAILS} at a time, new members will receive an email with a temporary password`;
  const instructions2 = `Choose existing members to add to this Villa, or enter emails of new people to invite up to ${MAX_EMAILS} at a time, new members will receive an email with a temporary password`;
  let memberSelector = <MemberSelector org={org} team={team} emails={emails} addUser={addUser} instructions1={instructions1} instructions2={instructions2}/>;
  const scopes = ['Member'];

  if (team) {
    title = 'Invite to Villa';
    scopes.push('Guest');
  } else {
    title = 'Invite to Organization';
    scopes.push('Admin');
  }

  if (!permissionAdmin) {
    return null;
  }

  return (
    <Modal show={show}
           className="invite-people"
           animation={false}
           onShow={showModal}
           onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {memberSelector}
        <div className="row">
          <div className="col">
            <InputGroup>
              <FormControl
                type="text"
                as="textarea"
                rows={4}
                value={emails}
                onChange={(event: any) => setEmails(event.target.value)}
                placeholder="email1@example.com, email2@example.com, ..."
                aria-label="Email addresses"
                disabled={!enabled}
                autoFocus
              />
            </InputGroup>
          </div>
        </div>
        <DropdownScope titleScope="Invite as" scope={scope} setScope={setScope} scopes={scopes}/>
        {error ?
          (
            <div className="row error">
              <div className="col">
                {(error as any)?.message}
              </div>
            </div>
          )
          : null
        }
      </Modal.Body>
      <Modal.Footer>
        <div className="row px-0">
          <div className="col text-right">
            <Button
              variant="secondary"
              onClick={onHide}
              disabled={!enabled}
            >
              Cancel
            </Button>
            <Button
              onClick={inviteUsers}
              style={{marginLeft: "10px"}}
              variant="primary"
              disabled={!enabled}
            >
              Invite
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default InvitePeople;
